export default __webpack_public_path__ + "static/media/delete-round.8f4689c3.svg";